import { DepositTransactionsPage } from 'features/transactions';

export const AdminDepositTransactionsPage: React.FC = () => (
  <DepositTransactionsPage />
);
